import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  selector: 'app-load-more',
  template: `
    <ng-content></ng-content>
    @if (showIndicator() && !loading()) {
      <div class="d-flex justify-content-center">
        <button im-button (click)="onLoadMore()">
          {{ 'LOAD_MORE_L' | translate }}
        </button>
      </div>
    }
    @if (loading()) {
      @for (i of [].constructor(5); track i) {
        <div class="skeleton" [style]="skeletonStyle"></div>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioButtonComponent, TranslatePipe]
})
export class LoadMoreComponent {
  readonly showIndicator = input(true);
  readonly loading = input(false);
  readonly loadMore = output();
  public skeletonStyle = {
    height: '25px',
    margin: '5px 0'
  };

  public onLoadMore() {
    this.loadMore.emit();
  }
}
